module.exports = __webpack_public_path__ + "static/media/wifi.15d626e9.svg";